import { Component } from '@angular/core';

@Component({
  selector: 'app-maker-layout',
  templateUrl: './maker-layout.component.html',
  styleUrls: ['./maker-layout.component.scss'],
})
export class MakerLayoutComponent {
}
